module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_clear_deskstop.427f19c9.jpg";